module.exports = __webpack_public_path__ + "img/residenziale_pressed.0e9ec086.png";